import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Twitch, Twitter, Instagram, Youtube } from "lucide-react";
import api from "@/lib/api";
import { useUiTexts } from "@/lib/uiTexts";
import DiscordIcon from "@/components/DiscordIcon";

const NETWORKS = [
  { key: "twitch", label: "Twitch", Icon: Twitch },
  { key: "twitter", label: "X / Twitter", Icon: Twitter },
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "youtube", label: "YouTube", Icon: Youtube },
  { key: "discord", label: "Discord", Icon: DiscordIcon },
];

export default function Footer() {
  const texts = useUiTexts();
  const [links, setLinks] = useState({});

  useEffect(() => {
    api.get("/socials").then((r) => setLinks(r.data)).catch(() => {});
  }, []);

  const active = NETWORKS.filter((n) => links[n.key]);

  return (
    <footer className="border-t border-orange-500/20 bg-[#04070F]">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-10 sm:flex-row sm:justify-between sm:px-8">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="Emisphere Esport" className="h-9 w-9 object-contain" />
          <div>
            <p className="font-heading text-lg font-black uppercase">Emisphere Esport</p>
            <p className="text-xs text-slate-500">{texts.footer_baseline}</p>
          </div>
        </div>
        {active.length > 0 && (
          <div className="flex items-center gap-1 text-slate-400">
            {active.map(({ key, label, Icon }) => (
              <a key={key} href={links[key]} target="_blank" rel="noreferrer" aria-label={label}
                data-testid={`social-${key}`} className="flex h-11 w-11 items-center justify-center transition-colors hover:text-orange-400">
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        )}
        <div className="flex flex-col items-center gap-3 sm:items-end">
          <div className="flex flex-wrap items-center gap-3">
            <Link to="/faq" data-testid="footer-faq-link"
              className="inline-flex min-h-11 items-center rounded-lg border border-orange-500/40 px-4 text-xs font-bold uppercase tracking-widest text-orange-400 transition-all hover:scale-[1.02] hover:bg-orange-500/10">
              FAQ
            </Link>
            <Link to="/mentions-legales" data-testid="footer-legal-link"
              className="inline-flex min-h-11 items-center text-xs font-bold uppercase tracking-widest text-slate-400 transition-colors hover:text-orange-400">
              Mentions légales
            </Link>
            <Link to="/cgv" data-testid="footer-cgv-link"
              className="inline-flex min-h-11 items-center text-xs font-bold uppercase tracking-widest text-slate-400 transition-colors hover:text-orange-400">
              CGV
            </Link>
          </div>
          <p className="text-xs text-slate-500">© 2026 Emisphere Esport — Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
}

